<template>
    <div :class="$attrs.class">
        <label v-if="label" class="form-label" :for="id">{{ label }}:</label>
        <div :id="id" class="form-select" :class="{ error: error }">
            <div v-for="option in options" :key="option.value">
                <input type="checkbox"
                       :value="option.value"
                       v-model="selected"
                       v-show="showCheckboxes"
                       :disabled="!showCheckboxes">
                {{ option.text }}
            </div>
        </div>
        <div v-if="error" class="form-error">{{ error }}</div>
    </div>
</template>

<script>
import { v4 as uuid } from 'uuid'

export default {
    inheritAttrs: false,
    props: {
        id: {
            type: String,
            default() {
                return `multiselect-input-${uuid()}`
            },
        },
        options: {
            type: Array,
            default: () => []
        },
        error: String,
        label: String,
        modelValue: {
            type: Array,
            default: () => []
        },
        showCheckboxes: {
            type: Boolean,
            default: true
        }
    },
    emits: ['update:modelValue'],
    data() {
        return {
            selected: this.modelValue,
        }
    },
    watch: {
        selected(newValue) {
            this.$emit('update:modelValue', newValue);
        },
        modelValue(newValue) {
            this.selected = newValue;
        }
    },
}
</script>

<style scoped>
.form-select div {
    padding: 8px;
}
</style>
